<template>
    <div class="container pt-3">
        <div class="row justify-content-lg-center">
            <div class="col-lg-12" style="font-size: 0.8rem">
                <div class="d-flex justify-content-between align-items-center" style="height: 37.79px; margin-bottom: 20px">
                    <div class="d-flex align-items-baseline" style="gap: 10px">
                        <h1 class="h1-title" style="font-weight: 500 !important; line-height: 21px">
                            <a href="javascript:;" @click="goBack" class="text-decoration-none text-reset">
                                {{ $t('views.transactions.title') }}
                            </a>
                            <span> > Detay</span>
                        </h1>
                    </div>
                    <div class="d-flex align-items-center sm-flex-column">
                        <div class="date-picker-wrapper">
                            <DateRangePicker :callback="handleDate" :singleDatePicker="false" :dateData="date_range" openPosition="left" :language="$i18n.locale" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="action-header">
            <div class="d-flex justify-content-between align-items-center sm-flex-column">
                <div class="d-flex sm-flex-column">
                    <div class="d-flex">
                        <div class="d-flex flex-column justify-content-center" style="border-right: 0.6px solid #e7eaf3; margin-right: 8px; padding-right: 15px; color: #677788">
                            <strong>{{ transactionDetailsTotal }}</strong>
                            <span>{{ $t('views.transactions.result') }}</span>
                        </div>
                        <div class="mr-8">
                            <select v-model="perPage" class="form-select form-select-sm">
                                <option v-for="i in [10, 25, 50, 100]" :key="i" :value="i">{{ i }} {{ $t('views.transactions.perPage') }}</option>
                            </select>
                        </div>
                        <div class="mr-8">
                            <select v-model="currentPage" class="form-select form-select-sm">
                                <option v-for="n in totalPages" :key="n" :value="n">{{ n }}. {{ $t('views.transactions.page') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="search-form">
                        <input v-model="searchQuery" class="form-control form-control-sm" type="text" :placeholder="$t('views.transactions.search')" style="font-size: 13px; height: 37.5px; min-width: 310px !important" @keyup.enter="search" />
                        <button class="btn btn-sm btn-link" style="height: 37.5px; line-height: 1; position: absolute; top: -2px; right: 0" @click="search">
                            <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <TransactionsDetail />
    </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue'
import TransactionsDetail from '@/components/Transactions/TransactionsDetail.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

moment.utc()

export default {
    name: 'TransactionDetailView',
    components: {
        DateRangePicker,
        TransactionsDetail,
    },
    data() {
        return {
            isFilterVisible: false,
            showDateRangePicker: false, // Tarih seçicisinin görünürlüğünü kontrol eden flag
            isDateRangeSelected: false, // Kullanıcının bir tarih aralığı seçip seçmediğini belirtir
            date_range: {
                startDate: new Date(new Date().getFullYear(), 0, 1), // Bu yılın başlangıcı
                endDate: new Date(new Date().getFullYear(), 11, 31), // Bu yılın sonu
            },
            daysShortcuts: ['today', 'thisWeek', 'thisMonth', 'pastMonth', 'thisYear'],
            currentShortcut: 'thisYear',
        }
    },
    computed: {
        ...mapState('transactions', {
            filterParams: (state) => state.filterParams,
            transactionDetailsState: (state) => state.transactionDetails,
        }),
        sessionDateRange() {
            return sessionStorage.getItem('dateRangeTransactionDetail')
        },
        searchQuery: {
            get() {
                return this.filterParams.search
            },
            set(value) {
                this.updateFilterParams({ key: 'search', value })
            },
        },
        perPage: {
            get() {
                return this.filterParams.perPage
            },
            set(value) {
                this.updateFilterParams({ key: 'perPage', value })
            },
        },
        currentPage: {
            get() {
                return this.filterParams.page
            },
            set(value) {
                this.updateFilterParams({ key: 'page', value })
            },
        },
        totalPages() {
            const total = this.transactionDetailsState?.total || 0
            return Math.ceil(total / this.filterParams.perPage) || 1
        },
        transactionDetailsTotal() {
            return this.transactionDetailsState?.total || 0
        },
    },
    created() {
        this.date = this.sessionDateRange ? [this.sessionDateRange.split(',')[0], this.sessionDateRange.split(',')[1]] : [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]

        // Search inputunu resetle
        this.resetSearch()

        // Tarih aralığı bilgisini store'a ekleyelim
        this.updateFilterParams({
            key: 'dateRange',
            value: {
                startDate: moment(this.date_range.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.date_range.endDate).format('YYYY-MM-DD'),
            },
        })

        // URL'den transaction ID'sini al ve detayları yükle
        const transactionId = this.$route.params.id
        if (transactionId) {
            this.getTransactionDetails(transactionId)
        }
    },
    methods: {
        ...mapActions('transactions', ['getTransactionDetails', 'updateFilterParams']),

        resetSearch() {
            // Search inputunu sıfırla
            this.updateFilterParams({ key: 'search', value: '' })
        },
        setDateRangShort(startDate, endDate) {
            this.date_range = {
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
            }
            this.showDateRangePicker = true // Tarih seçildiğinde görünür olsun
            this.isDateRangeSelected = true // Kullanıcı bir tarih aralığı seçti

            // Store'a tarih aralığını ekle
            this.updateFilterParams({
                key: 'dateRange',
                value: {
                    startDate: moment(startDate).format('YYYY-MM-DD'),
                    endDate: moment(endDate).format('YYYY-MM-DD'),
                },
            })

            // Detay verilerini yeniden yükle
            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        changeDateShortcut(day) {
            const today = moment().startOf('day').toDate()
            this.currentShortcut = day

            switch (day) {
                case 'today':
                    this.setDateRangShort(today, today)
                    break
                case 'thisWeek':
                    this.setDateRangShort(moment().subtract(6, 'days').toDate(), today)
                    break
                case 'thisMonth':
                    this.setDateRangShort(moment().startOf('month').toDate(), today)
                    break
                case 'pastMonth':
                    this.setDateRangShort(moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate())
                    break
                case 'thisYear':
                    this.setDateRangShort(new Date(new Date().getFullYear(), 0, 1), today)
                    break
            }
        },
        search() {
            // Store'daki arama parametresini güncelle ve detay verilerini yeniden çek
            this.updateFilterParams({ key: 'search', value: this.searchQuery })

            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        handleDate(data) {
            this.isDateRangeSelected = true

            // Store'a tarih aralığını ekle
            this.updateFilterParams({
                key: 'dateRange',
                value: {
                    startDate: moment(data.startDate).format('YYYY-MM-DD'),
                    endDate: moment(data.endDate).format('YYYY-MM-DD'),
                },
            })

            this.showDateRangePicker = true

            // Tarih aralığı değiştiğinde detay verilerini yeniden yükle
            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        activateDatePicker() {
            this.showDateRangePicker = true
        },
        goBack() {
            // URL parametresinden type bilgisini al
            const type = this.$route.params.type || 'summary'

            this.$router.push({
                name: 'transactions-type',
                params: {
                    type,
                },
            })
        },
    },
    watch: {
        perPage() {
            this.currentPage = 1
            console.log('Per page changed to:', this.perPage)

            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        currentPage() {
            console.log('Page changed to:', this.currentPage)

            const transactionId = this.$route.params.id
            if (transactionId) {
                this.getTransactionDetails(transactionId)
            }
        },
        '$route.params.id': {
            handler(newId) {
                if (newId) {
                    this.getTransactionDetails(newId)
                }
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
:root {
    --redesign-gray: #f8fafd;
    --redesign-primary: #ffb53e;
}
.dp__theme_light {
    --dp-primary-color: #ffb53e;
}
.store-tabs {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 5px;

    &__item {
        height: 53px;
        padding: 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        color: #132144;
        cursor: pointer;

        &:hover {
            background-color: #bdc5d133;
            color: #132144;
        }

        &.active {
            background-color: #bdc5d133;
            color: #132144;
        }

        .count-badge {
            padding: 3.67px 5.86px 3.67px 6.81px;
            border-radius: 800px;
            background-color: #677788;
            color: #fff;
            font-size: 10.5px;
            font-weight: 700;
            line-height: 12.71px;
            text-align: center;
        }
    }
}

body.is-sticky {
    .action-header {
        position: fixed;
        top: 30px;
        z-index: 5;
        width: calc(100% - 50px);

        > div {
            border-top: 1px solid #e7eaf3b2;
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    .custom-table-items {
        thead {
            box-shadow: 0px 60px 50px 0px #00203f40;
        }
    }
}

.action-header {
    & > div {
        display: block;
        background-color: var(--redesign-gray);
        margin-top: 10px;
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.94px;
        padding-left: 12px;
        padding-right: 12px;
        height: 69.79px;
    }
    &__btn {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
        height: 37px;
        padding-left: 10px;
        border-bottom: 0.6px solid #e7eaf3 !important;
        color: #677788 !important;
    }
}

.search-form {
    position: relative;
}

.dp__input_wrap {
    width: auto;
    > input {
        padding-inline-end: 12px !important;
        font-size: 14px;
        border: 0.6px solid #e7eaf3;
        color: #677788;
        width: 220px !important;
    }
}

.mr-8 {
    margin-right: 8px;
}

@media (width <= 767px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
    .sm-flex-column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start !important;
        align-items: baseline !important;
        gap: 0.5rem;
    }
    .action-header > div {
        height: auto !important;
    }
    .mr-8:last-child {
        margin-right: 0 !important;
    }
}

@media (width > 767px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
}
</style>
